import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Briefcase, ExternalLink, LifeBuoy, X } from "lucide-react";
import { isNavItemActive } from "navigation/navConfig";

const ROUTES_LOGO = "/images/ROUTES_LOGO.png";

export const openCareers = () => {
  const token = localStorage.getItem("TOKEN");
  const base = process.env.REACT_APP_CAREERS_URL || "https://talent.routes-app.com";
  const url = token ? `${base}?sso_token=${encodeURIComponent(token)}` : base;
  window.open(url, "_blank", "noopener,noreferrer");
};

const NavItem = ({ item, active }) => {
  const Icon = item.icon;
  return (
    <Link
      to={item.to}
      className={`cc-nav__item${active ? " is-active" : ""}`}
      aria-current={active ? "page" : undefined}
    >
      <Icon size={18} strokeWidth={2} aria-hidden="true" />
      <span>{item.label}</span>
      {item.badge > 0 && (
        <span className="cc-nav__badge" aria-label={`${item.badge} waiting`}>
          {item.badge > 99 ? "99+" : item.badge}
        </span>
      )}
    </Link>
  );
};

const SideNav = ({ sections, role, user, open, onClose }) => {
  const { pathname } = useLocation();
  const orgLogo = role !== "admin" && user?.club?.image;
  const orgName = role === "admin" ? "Routes" : user?.club?.name;

  return (
    <aside className={`cc-nav cc-bb${open ? " is-open" : ""}`} aria-label="Main navigation">
      <div className="cc-nav__brand">
        <Link to="/" className="cc-nav__home" onClick={onClose} aria-label="Home">
        <img
          className="cc-nav__logo"
          src={orgLogo || ROUTES_LOGO}
          alt={orgName || "Routes"}
          onError={(e) => {
            if (!e.currentTarget.src.endsWith(ROUTES_LOGO)) e.currentTarget.src = ROUTES_LOGO;
          }}
        />
        <div className="cc-nav__brand-text">
          <span className="cc-nav__product">Control Centre</span>
          {orgName && <span className="cc-nav__org">{orgName}</span>}
        </div>
        </Link>
        <button type="button" className="cc-icon-btn cc-nav__close" onClick={onClose} aria-label="Close menu">
          <X size={18} />
        </button>
      </div>

      <nav className="cc-nav__scroll">
        {sections.map((section) => (
          <div key={section.key} className="cc-nav__section">
            {section.title && <p className="cc-nav__title">{section.title}</p>}
            {section.items.map((item) => (
              <NavItem key={item.key} item={item} active={isNavItemActive(item, pathname)} />
            ))}
          </div>
        ))}
      </nav>

      <div className="cc-nav__footer">
        {(role === "admin" || role === "clubAdmin" || role === "tutor") && (
          <button type="button" className="cc-nav__item" onClick={openCareers}>
            <Briefcase size={18} strokeWidth={2} aria-hidden="true" />
            <span>Talent pool</span>
            <ExternalLink size={14} className="cc-nav__external" aria-hidden="true" />
          </button>
        )}
        <Link
          to="/support"
          className={`cc-nav__item${pathname === "/support" ? " is-active" : ""}`}
        >
          <LifeBuoy size={18} strokeWidth={2} aria-hidden="true" />
          <span>Support</span>
        </Link>
      </div>
    </aside>
  );
};

export default SideNav;
